import { useNavigate } from 'react-router-dom';
import { categories } from '../../../mocks/site';

const icons: Record<string, string> = {
  陈年旧瓜: 'ri-ancient-pavilion-line',
  考古重读: 'ri-archive-drawer-line',
  历史爆料: 'ri-newspaper-line',
  旧事重提: 'ri-refresh-line',
  当年真相: 'ri-question-line',
};

const accents: Record<string, string> = {
  陈年旧瓜: 'text-primary-700 bg-primary-100/70',
  考古重读: 'text-accent-700 bg-accent-100/70',
  历史爆料: 'text-secondary-700 bg-secondary-100/70',
  旧事重提: 'text-foreground-700 bg-foreground-100/60',
  当年真相: 'text-accent-700 bg-accent-100/70',
};

export default function CategoryBand() {
  const navigate = useNavigate();
  return (
    <section className="bg-background-100">
      <div className="container-x py-12 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-700">COLUMN ARCHIVE</p>
            <h2 className="mt-1 font-display text-2xl font-black text-foreground-900 md:text-3xl">
              五大栏目档案
            </h2>
          </div>
          <p className="hidden max-w-xs text-sm leading-6 text-foreground-600 md:block">
            每一条旧瓜都归档在它该在的格子，等待重新被打开的那天。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((c) => (
            <button
              key={c.slug}
              onClick={() => navigate(`/column/${c.slug}`)}
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 text-left transition-all hover:-translate-y-1 hover:border-accent-300 hover:shadow-[0_12px_28px_-14px_oklch(var(--foreground-950)_/_0.2)]"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-md text-xl ${accents[c.name]}`}>
                <i className={icons[c.name] || 'ri-archive-line'}></i>
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-foreground-900">{c.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                {c.count} 篇旧档
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}